import { useEffect, useState } from 'react'
import { getLang, setLang, onLangChange, LANGUAGE_NAMES, type Lang } from '../lib/i18n'

/**
 * Each language is offered IN ITS OWN SCRIPT — "ខ្មែរ" and "English" — never
 * behind a label like "Language" or a globe icon.
 *
 * Someone who cannot read the language the app is currently in also cannot read
 * a label telling them where to change it. The names of the languages are the
 * only text on this control that works in both directions, which is why they
 * are the whole control.
 */
export function LanguageSwitch({ compact }: { compact?: boolean }) {
  const [lang, set] = useState<Lang>(getLang())

  useEffect(() => onLangChange(() => set(getLang())), [])

  function choose(l: Lang) {
    setLang(l)
    set(l)
  }

  return (
    <div style={{ display: 'flex', gap: 6 }} role="group" aria-label="ខ្មែរ / English">
      {(['km', 'en'] as Lang[]).map((l) => (
        <button
          key={l}
          onClick={() => choose(l)}
          aria-pressed={lang === l}
          className={lang === l ? 'btn-primary' : ''}
          style={{
            minHeight: 44,
            padding: compact ? '8px 12px' : '10px 16px',
            fontSize: 15,
            ...(lang === l
              ? {}
              : { border: '2px solid var(--line)', background: 'var(--white)', color: 'var(--ink)' }),
            // Khmer needs the extra leading even on a button.
            lineHeight: 1.7,
          }}
        >
          {LANGUAGE_NAMES[l]}
        </button>
      ))}
    </div>
  )
}
